
import { ErrorModule } from '../modules/error'
import { TransactionModule } from '../modules/Transaction'
import { ModalModule } from '../modules/modal'
import { OrderModule } from '../modules/order/otelo'
import { PaymentModule } from '../modules/payment'

export const storeConfig = {
  modules: {
    Transaction: TransactionModule,
    error: ErrorModule,
    modal: ModalModule,
    orderProduct: OrderModule,
    payment: PaymentModule
  },
  actions: {
    clearState ({ commit }) {}
  }
}
